import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Page,
  DealStatusSelect,

} from '../shared';

import ReactTooltip from 'react-tooltip';

import {
  formatThousands,
  getDealCompletion,
  getClassModifierForConfidence,
  getDealItemsAtRisk,
} from '../../util';

import{
  getIcon
} from '../../util/icons';

import { UpdateDealModal } from '../modals';

import { fetchDealsForEmployee } from '../../actions/deals';

import { Redirect, Link } from 'react-router-dom';

class ImperativesPage extends Component {

  state = {
    pageMessage: null,
    updatingDeal: null,
    redirectingToDeal: false,
    filterByStatus: 'open',
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    let employeeId = params.employeeId;

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnDeals: false,
      });
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnDeals: true,
      });
    }

    //fetch deals if unloaded or if loaded for other employee
    if(!this.props.deals || this.props.deals.length === 0 || this.props.deals[0].userId !== employeeId){
      this.props.fetchDealsForEmployee(employeeId);
    }
  }

  reloadDeals(){
    this.props.fetchDealsForEmployee(this.state.employeeId);
  }

  renderDeal(deal){

    const { _id, name, status, estimatedValue, estimatedCloseDate, completion, itemsAtRisk, userId } = deal;

    if(!_id){
      return null;
    }

    const { confidence } = (completion || {});

    const dealConfidenceClassModifier = getClassModifierForConfidence(confidence);

    return(
      <Link key={_id} to={`/people/${userId}/imperatives/${_id}`}>
        <li className="deal">
          <div className="deal-name">{name}</div>
          <div className="deal-primry-info">${formatThousands(estimatedValue)}</div>
          <div className="deal-secondary-info">{moment(estimatedCloseDate).format('MM/DD/YY')}</div>

          {itemsAtRisk && itemsAtRisk.length > 0 &&
            <div data-tip={`Deal has ${itemsAtRisk.length} items at risk`} className="deal-at-risk">{getIcon('warning')}<div className="count">{itemsAtRisk.length}</div></div>
          }
          <div className="deal-confidence-label">
            <div className={`dial confidence-${dealConfidenceClassModifier}`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={confidence}></div>
              <div className="dial__content" style={{lineHeight: '50px'}}>{confidence}</div>
              <div className="dial__denominator">/100</div>
            </div>
          </div>
        </li>
      </Link>
    );

    // return(
    //   <li key={_id} onClick={(e) => { e.stopPropagation(); return false; }}>
    //     <div className="deal-name">{name}</div>
    //     <div className="deal-value">${formatThousands(estimatedValue)}</div>
    //     <div className="deal-actions">
    //       <div
    //         onClick={() => { this.beginUpdatingDeal(deal); }}
    //         className="deal-action edit"
    //       >Edit</div>
    //       <Link to={`/imperatives/${_id}`}>
    //         <div className="deal-action view">View details</div>
    //       </Link>
    //     </div>
    //   </li>
    // );
  }

  dealsForView(){

    const { deals } = this.props || [];
    const { filterByStatus } = this.state;

    const filteredDeals = _.filter(deals, { status: filterByStatus });

    return _.map(filteredDeals, deal => {
      return {
        ...deal,
        completion: getDealCompletion(deal),
        itemsAtRisk: getDealItemsAtRisk(deal),
      }
    });
  }

  renderDeals(){

    const deals = this.dealsForView();

    return(
      <div className="page-content">
        <div className="page-section">
          <ul className="deals-list">
            {_.map(deals, this.renderDeal.bind(this))}
            <ReactTooltip effect="solid" place="top"/>
          </ul>
        </div>
      </div>
    )
  }

  beginUpdatingDeal(deal){
    this.setState({
      updatingDeal: { ...deal }
    });
  }

  beginAddingNewDeal(){

    const newDeal = {
      userId: this.state.employeeId,
      status: 'open',
      estimatedCloseDate: moment().valueOf(),
    };

    this.setState({
      updatingDeal: newDeal
    });
  }

  afterDealUpdate(deal){
    this.reloadDeals();

    this.setState({
      updatingDeal: null
    });
  }
  afterDealCreate(deal){
    this.reloadDeals();

    this.setState({
      updatingDeal: null,
      redirectingToDeal: deal._id
    });
  }

  renderDealStatusSelect(){
    return(
      <DealStatusSelect
        value={this.state.filterByStatus}
        onUpdate={newStatus => { this.setState({ filterByStatus: newStatus }); }}
      />
    )
  }

  renderDealsPageTitle(){

    const { filterByStatus } = this.state;

    const { viewingUser, deals } = this.props;

    if(!deals){
      return;
    }

    const dealTotalToDisplay = _.reduce(deals, (memo, deal) => {
      return memo + (deal.status === filterByStatus ? deal.estimatedValue : 0);
    }, 0);

    const dealTotalLabel = filterByStatus === 'open' ? 'in pipeline' : (filterByStatus === 'won' ? 'in won deals' : 'in lost deals');

    let dealOwnersName = 'My';

    if(viewingUser){
      dealOwnersName = `${viewingUser.firstName}'s`;
    }

    return(
      <div className="page-title">
        <h1>{dealOwnersName} {filterByStatus.substring(0,1).toUpperCase() + filterByStatus.substring(1)} Deals</h1>
        <h3>${formatThousands(dealTotalToDisplay)} {dealTotalLabel}</h3>
      </div>
    )
  }

  render(){

    if(this.state.redirectingToDeal){
      const redirectToUrl = `${this.state.isOwnDeals ? '' : `/people/${this.state.employeeId}`}/imperatives/${this.state.redirectingToDeal}`;
      return <Redirect to={redirectToUrl} />
    }

    const loading = !this.props.user || this.props.loadingDeals;

    return (
      <Page
        pageClass="imperatives"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        {this.renderDealsPageTitle()}
        <div className="page-actions">
          <button
            onClick={this.beginAddingNewDeal.bind(this)}
            className="button primary">Add new deal</button>
          {this.renderDealStatusSelect()}
        </div>
        {this.renderDeals()}

        <UpdateDealModal
          hide={() => { this.setState({ updatingDeal: null }) }}
          editingDeal={this.state.updatingDeal}
          visible={!!this.state.updatingDeal}
          onCreate={this.afterDealCreate.bind(this)}
          onUpdate={this.afterDealUpdate.bind(this)}
        />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    loadingDeals: state.deals.loading,
    deals: state.deals.data,
    viewingUser: state.viewingUser.data,
  }
}

export default connect(mapStateToProps, { fetchDealsForEmployee })(ImperativesPage);



// WEBPACK FOOTER //
// ./src/components/imperatives/index.js